import { ToastProvider } from '@citizen-walk/shared-ui';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { startVersionPolling } from './lib/appVersion';
import { initGa4 } from './lib/ga4';
import { initSentry } from './lib/sentry';
import './index.css';

// Sprint BG Part 2 — Sentry / GA4 (env 空時 no-op)。dep (@sentry/react) は未 install。
void initSentry();
initGa4();

// 新バージョン検出 (2026-06-12): 管理アプリは SW 非搭載のため version.json ポーリングで新版を
// 検出し、UpdateBanner で任意更新を促す (本番ビルドのみ稼働、dev は内部で skip)。
startVersionPolling();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Failed to find the root element');
}

createRoot(rootElement).render(
  <StrictMode>
    <ToastProvider>
      <App />
    </ToastProvider>
  </StrictMode>,
);
